import { createFileRoute } from "@tanstack/react-router";

import { NotificationsPage } from "../../../../areas/seller/more/notifications/NotificationsPage";

export const Route = createFileRoute("/app/_seller/more/notifications")({
  component: NotificationsPage,
});
